import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { api } from "utils/hostname";
import url from "../../../../../url";
import type { FortuneWheelSpinResponse } from "../type/FortuneWheel";
import { useFortuneWheelStore } from "../store/fortuneWheel";
import { pickWinnerSection } from "../utils/wheel";

export const useFortuneWheelSpinMutation = () => {
  return useMutation<FortuneWheelSpinResponse, AxiosError, void>({
    mutationFn: async () => {
      const response = await api(true, true).post<FortuneWheelSpinResponse>(
        url.config.api.fortuneWheel.spin,
        {},
      );
      const payload = response?.data;
      if (!payload || typeof payload !== "object") {
        throw new Error("Spin response is empty or invalid");
      }
      return payload;
    },

    onSuccess: (payload) => {
      const { setSection } = useFortuneWheelStore.getState();

      const winner = pickWinnerSection(payload);
      setSection(winner);
    },

    onError: (err) => {
      const { setError, setSection } = useFortuneWheelStore.getState();
      setError(err?.message || "Spin request failed");
      setSection(null);
    },
  });
};
